import LikedFilters from './filters/LikedFilters';
import LikedOutput from './output/LikedOutput';

import scss from '../../Id8.module.scss';

function LikedTab() {
  return (
    <div className={scss.outputWrapper}>
      <LikedFilters />
      <LikedOutput />
    </div>
  );
}

export default LikedTab;
